export const numberFormat = (
    number: number,
    decimalToShow?: number,
    minDecimalToShow: number = 0
) => {
    const formatter = Intl.NumberFormat('en-US', {
        maximumFractionDigits:
            decimalToShow || decimalToShow === 0 ? decimalToShow : 2,
        minimumFractionDigits: minDecimalToShow,
    });

    return formatter.format(number);
};

export const numberFormatBreak = (
    number: number,
    decimalToShow?: number,
    minDecimalToShow?: number
) => {
    if (number === 0) {
        return '--';
    }
    const formatter = Intl.NumberFormat('en-US', {
        maximumFractionDigits:
            decimalToShow || decimalToShow === 0 ? decimalToShow : 2,
        minimumFractionDigits: minDecimalToShow ? minDecimalToShow : 0,
    });

    return formatter.format(number);
};

export const numberFormatNew = (number: number, decimalToShow?: number) => {
    if (number < 0.01) {
        const formatter = Intl.NumberFormat('en-US', {
            maximumFractionDigits: 6,
            minimumFractionDigits: 0,
        });

        return formatter.format(number);
    }

    const formatter = Intl.NumberFormat('en-US', {
        maximumFractionDigits:
            decimalToShow || decimalToShow === 0 ? decimalToShow : 2,
        minimumFractionDigits: 0,
    });

    return formatter.format(number);
};

export const addressFormat = (address?: string) => {
    if (!address) {
        return '';
    }

    const theFirst = address.substring(0, 4);
    const theLast = address.slice(address.length - 4);

    return `${theFirst}...${theLast}`;
};

export const numberFormatPercentage = (
    number: number,
    decimalToShow?: number
) => {
    const formatter = Intl.NumberFormat('en-US', {
        style: 'percent',
        maximumFractionDigits:
            decimalToShow || decimalToShow === 0 ? decimalToShow : 2,
        minimumFractionDigits: 0,
    });

    return formatter.format(number);
};

export const numberFormatChange = (number: number, decimalToShow?: number) => {
    const formatter = Intl.NumberFormat('en-US', {
        maximumFractionDigits:
            decimalToShow || decimalToShow === 0 ? decimalToShow : 2,
        minimumFractionDigits: 1,
    });

    return formatter.format(number);
};

export function formatNumberBalance(number: number) {
    if (number >= 1e9) {
        return numberFormat(number / 1e9, 2) + 'B';
    }
    if (number >= 1e6) {
        return numberFormat(number / 1e6, 2) + 'M';
    }
    if (number >= 1e3) {
        return numberFormat(number / 1e3, 2) + 'K';
    }
    return numberFormat(number, 2);
}

export function newFormatNumberBalance(number: number) {
    if (number >= 1e9) {
        return numberFormat(number / 1e9, 1) + 'B';
    }
    if (number >= 1e6) {
        return numberFormat(number / 1e6, 1) + 'M';
    }
    if (number >= 1e3) {
        return numberFormat(number / 1e3, 1) + 'K';
    }
    return numberFormat(number, 1);
}

export function numberFloor(number: number) {
    if (!number) {
        return 0;
    }

    return Math.floor(number * 100) / 100;
}
